/**
 * Condense a list of class names and conditional class names into a single className property value
 * 
 * @param {[*]} classes
 * @returns {String} A single className
 */
export const classNames = (...classes) => {
    const classList = classes
        .filter(x => typeof x === 'string' && x.length);

    return dedupe(classList).join(' ');
};

/**
 * Dedupes an array
 * @param {[*]} values Array of values to dedupe
 */
function dedupe(values) {
    return values.map((value, index, collection) => {
        if (collection.lastIndexOf(value) != index)
            return null;
        return value;
    }).filter(v => v !== null);
}

export default classNames;